import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import '../../styles/AdminModal.css';

const LeadDetailsModal = ({ isOpen, onClose, lead }) => {
  useEffect(() => {
  }, [isOpen]);

  if (!isOpen || !lead) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Lead Details</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        <div className="admin__modal-body">
          <p><strong>ID:</strong> #{lead.id}</p>
          <p><strong>First Name:</strong> {lead.first_name}</p>
          <p><strong>Last Name:</strong> {lead.last_name}</p>
          <p><strong>Email:</strong> {lead.email}</p>
          <p><strong>Phone:</strong> {lead.phone}</p>
          <p><strong>Date:</strong> {lead.date || '-'}</p>
          <p><strong>Hour:</strong> {lead.hour || '-'}</p>
          <p><strong>Status:</strong> {lead.status}</p>
          <p><strong>Destination:</strong> {lead.destination.name}</p>
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default LeadDetailsModal;